import React from 'react';
import Icon from './Icon';

const ChevronLeft = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <title>Chevron Left</title>
    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
  </Icon>
);

export default ChevronLeft;
